import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      cardContainer: {
        justifyContent: 'space-around',
        background: 'transparent',
        margin: '0px 0px 20px 0px',
        [theme.breakpoints.down('lg')]: {
          minHeight: '1300px',
          alignItems: 'center',
          gap: '25px',
          paddingTop: '25px'
        },
        [theme.breakpoints.only('lg')]: {
          padding: '0px 40px',
          gap: '0'
        }
      },
      overlayHeader: {
        lineHeight: 1,
        textAlign: 'center',
        fontSize: '56px',
        fontWeight: 600,
        letterSpacing: 0,
        fontFamily: props.fontFamily
      }
    })
  );
